module.exports = __webpack_public_path__ + "img/logo.97c139b7.png";